export enum TrafficSource {
    DEFAULT = 'home',
    EXOCLICK = 'exoclick',
    PROPELLER = 'propellerads',
}
